<template>
  <basic-container>
    <el-form ref="form" :model="amountForm" label-width="20px" style="margin-top: 10px">
      <el-row>
        <el-col span="1" offset="3">
          <img
            class="el-avatar el-avatar--circle"
            src="./png/should-amount.png"
            style="width: 60px; height: 60px; background: none"
          />
        </el-col>
        <el-col span="4" style="margin-top: 20px; font-size: 18px; padding-left: 5px">
          应收金额：<strong style="color: red">{{ amountForm.chargeTotalSum }}元</strong>
        </el-col>
        <el-col span="1">
          <img
            class="el-avatar el-avatar--circle"
            src="./png/balance-amount.png"
            style="width: 60px; height: 60px; background: none"
          />
        </el-col>
        <el-col span="4" style="margin-top: 20px; font-size: 18px; padding-left: 5px">
          实收差额：<strong style="color: red">{{ amountForm.balanceAmountSum }}元</strong>
        </el-col>
        <el-col span="1">
          <img
            class="el-avatar el-avatar--circle"
            src="./png/charge-amount.png"
            style="width: 60px; height: 60px; background: none"
          />
        </el-col>
        <el-col span="4" style="margin-top: 20px; font-size: 18px; padding-left: 5px">
          实收金额：<strong style="color: red">{{ amountForm.chargeAmountSum }}元</strong>
        </el-col>
      </el-row>
      <el-divider></el-divider>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot-scope="scope" slot="parkingLotIdSearch">
        <selectSearch  v-model="parkingLotIdSearch" :dicData="spaceList"></selectSearch>
        <!-- <el-select v-model="parkingLotIdSearch" style="width: 100%" placeholder="车场名称">
          <el-option v-for="item in spaceList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select> -->
      </template>
      <template slot-scope="scope" slot="unusualTimeRangeSearch">
      <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.unusualStartTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
              placeholder="开始日期"
             
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.unusualEndTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
             
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot-scope="{ row }" slot="carImage">
        <el-button slot="reference" type="primary" size="small" @click="showImage(row.carImage)">
          图片
        </el-button>

        <!-- <img
          style="height: 40px"
          :src="row.carImage"
          @mouseover="(e) => showImage(e, row.carImage)"
          @mouseout="hideImage"
        /> -->
      </template>

      <template slot-scope="scope" slot="menu">
        <el-button
          v-if="scope.row.status === 1"
          type="text"
          icon="el-icon-check"
          size="small"
          @click.stop="confirm(scope.row)"
          >确认
        </el-button>
        <el-button
          v-if="showRecoverBtn(scope.row)"
          type="text"
          icon="el-icon-s-check"
          size="small"
          @click.stop="recover(scope.row)"
          >追回
        </el-button>
      </template>
      <template slot="chargeTotal" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.chargeTotal) }}
      </template>
      <template slot="discountAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.discountAmount) }}
      </template>
      <template slot="chargeAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.chargeAmount) }}
      </template>
      <template slot="balanceAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.balanceAmount) }}
      </template>
    </avue-crud>
    <el-dialog append-to-body :visible.sync="showImgDialog">
      <!-- <img :src="imgUrl" width="100%" alt=""> -->
      <el-image
        style="width: 100%"
        z-index="5000"
        :src="imgUrl"
        :preview-src-list="[imgUrl || carImg]"
      >
        <div slot="error" class="image-slot">
          <img src="./png/car.png" style="width: 100%" width="100%" alt="" />
        </div>
      </el-image>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  handleUnusual,
} from '@/views/v4ward/park/unusualv2/api/carv4wardunusual';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { mapGetters } from 'vuex';
import { tempImgUrl } from '@/api/base/region.js';
import { getStore } from '@/util/store.js';
export default {
  data() {
    return {
      tenantId: getStore({ name: 'userInfo' }).tenant_id,
      showImgDialog: false,
      imgUrl: '',
      form: {},
      query: {
        unusualStartTime:'',
        unusualEndTime:''
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      carImg: require('./png/car.png'),
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: true,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: false,
        addBtn: false,
        selection: false,
        menu: true,
        dialogClickModal: false,
        menuWidth: 140,
        refreshBtn: true,
        columnBtn: true,
        stripe: true,
        column: [
          {
            // 用于搜索使用
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'select',
            display: false,
            hide: true,
            showColumn: false,
            search: true,
            searchslot: true,
          },
          {
            label: '区域名称',
            prop: 'regionName',
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            search: true,
            rules: [
              {
                required: true,
                message: '请输入车牌',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆分类',
            prop: 'carType',
            width: 120,
          },

          {
            label: '通道名称',
            prop: 'passageName',
          },
          {
            label: '车辆图片',
            prop: 'carImage',
            width: 90,
            slot: true,
          },
          {
            label: '违规类型',
            prop: 'unusualType',
            width: 140,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=park_unusual_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            search: true,
          },
          {
            label: '违规时间',
            prop: 'unusualTime',
            width: 140,
            rules: [
              {
                required: true,
                message: '请输入违规时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '违规操作人',
            prop: 'unusualOperatePerson',
            width: 80,
          },
          {
            label: '停车时长',
            prop: 'stopTime',
            width: 120,
          },
          {
            label: '应付金额',
            prop: 'chargeTotal',
            slot: true,
            align: 'right',
            width: 80,
          },
          {
            label: '优惠金额',
            prop: 'discountAmount',
            slot: true,
            align: 'right',
            width: 80,
          },
          {
            label: '实付金额',
            prop: 'chargeAmount',
            slot: true,
            align: 'right',
            width: 80,
          },
          {
            label: '实收差额',
            prop: 'balanceAmount',
            slot: true,
            align: 'right',
            width: 80,
          },
          {
            label: '状态',
            prop: 'status',
            search: true,
            type: 'select',
            width: 60,
            dicData: [
              { label: '待确认', value: 1 },
              { label: '已追回', value: 2 },
              { label: '已确认', value: 3 },
            ],
          },
          {
            label: '计费开始时间',
            prop: 'feeStartTime',
            width: 140,
          },
          {
            label: '计费结束时间',
            prop: 'feeEndTime',
            width: 140,
          },
          {
            label: '值班人',
            prop: 'createUserName',
            width: 100,
            search: true,
          },
          {
            label: '操作人',
            width: 100,
            prop: 'recoverUserName',
          },
          {
            label: '违规时间',
            prop: 'unusualTimeRange',
            hide: true,
            searchSpan: 12,
            search: true,
            showColumn: false,
            searchslot: true,
            type: 'datetime',
            searchRange: true,
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
        ],
      },
      data: [],
      spaceList: [],
      parkingLotIdSearch: '',
      defaultParkingLotIdSearch: '',
      amountForm: {
        chargeTotalSum: '125.00',
        balanceAmountSum: '101.00',
        chargeAmountSum: '24.00',
      },
      showPic: '',
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        confirmBtn: this.vaildData(this.permission.carv4wardunusual_confirm, false),
        recoverBtn: this.vaildData(this.permission.carv4wardunusual_recover, false),
        delBtn: false,
        //delBtn: this.vaildData(this.permission.carv4wardunusual_delete, false),
        editBtn: false,
        //editBtn: this.vaildData(this.permission.carv4wardunusual_edit, false)
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.option.height = this.bodyHeight - 480;
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        // 默认查询第一个
        this.parkingLotIdSearch = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 480) {
              this.option.height = this.bodyHeight - 380;
            } else {
              this.option.height = this.bodyHeight - 480;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  methods: {
    showRecoverBtn(row) {
      //是否显示追回按钮
      if (row.status !== 1) {
        return false;
      }
      return Number.parseFloat(row.balanceAmount) > 0;
    },
    recover(row) {
      //追回
      this.$confirm('确认已经追回金额：' + row.balanceAmount + '元？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return handleUnusual({ id: row.id, status: 2, balanceAmount: row.balanceAmount });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    confirm(row) {
      //确认
      this.$confirm('确认异常结果？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return handleUnusual({ id: row.id, status: 3 });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    showImage(imgUrl) {
      tempImgUrl({ fileUrl: imgUrl, tenantId: this.tenantId }).then((res) => {
        console.log(res);
        this.imgUrl = res.data;
        this.showImgDialog = true;
      });
    },
    hideImage() {
      document.body.removeChild(this.img);
      this.showPic = '';
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      } else if ('add' === type) {
        this.cleanForm();
      }
      done();
    },
    cleanForm() {
      for (let key in this.form) {
        this.form[key] = null;
      }
    },
    searchReset() {
      this.query.plateNumber = '';
      this.query.unusualType = '';
      this.query.status = '';
      this.query.createUserName = '';
      this.query.unusualStartTime='';
      this.query.unusualEndTime='';
      this.parkingLotIdSearch = this.spaceList[0].id;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query.plateNumber = params.plateNumber;
      this.query.unusualType = params.unusualType;
      this.query.status = params.status;
      this.query.createUserName = params.createUserName;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      if (this.vdui.isEmpty(this.parkingLotIdSearch)) {
        return;
      }
      this.query.parkingLotId = this.parkingLotIdSearch;

    
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.pages.total;
          this.data = data.pages.records;
          //统计金额
          this.amountForm = data.amountSum;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
